/** @jsxImportSource theme-ui */
import React from 'react';

import BdCaseIncidenceInheritedIcon from 'components/_common/Icon/BdCaseIncidenceIcon/BdCaseIncidenceInheritedIcon';
import { Typography } from 'components/_common/Typography';

type CaseIncidenceDisclosureProps = {
  locationName: string;
  parentLocationName: string;
};
const CaseIncidenceDisclosure: React.FC<CaseIncidenceDisclosureProps> = ({
  locationName,
  parentLocationName,
}) => {
  return (
    <div id="case-incidence-disclosure" sx={{ display: 'flex', mt: '12px' }}>
      <BdCaseIncidenceInheritedIcon valignTop="2px" />
      <Typography
        className="disclosure-text"
        variant="caption"
        color="stone70"
        marginBottom="0"
        sx={{ ml: '4px' }}
      >
        {locationName} doesn&apos;t have enough data to display for incidence cases, incidence for{' '}
        {parentLocationName} is being displayed.
      </Typography>
    </div>
  );
};

export default CaseIncidenceDisclosure;
